import { IModalInstanceService, IModalService } from "angular-ui-bootstrap";
import { IListProperty } from "..";

export class ChartSettingsModalOpener {
  public static $inject = ["$uibModal"];
  private modal: IModalInstanceService;
  constructor(private $uibModal: IModalService) {}

  open(listProperties: IListProperty[]): IModalInstanceService {
    if (!this.modal) {
      this.modal = this.$uibModal.open({
        windowClass: "chart-settings-modal",
        openedClass: "chart-settings-open",
        backdropClass: "chart-settings-backdrop",
        component: "chartSettings",
        backdrop: "static",
        resolve: {
          listProperties: () => listProperties,
        },
      });

      this.modal.closed.then(() => {
        this.modal = null;
      });
    }

    return this.modal;
  }

  close(): void {
    if (this.modal) {
      this.modal.close();
    }
  }
}
